import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import rootReducer from "./reducers";
import { environmentConstants } from "../constants";

// Function to create store enhancers with Redux DevTools
const createEnhancers = () => {
  if (
    process.env.REACT_APP_ENVIRONMENT === environmentConstants.DEVELOPMENT &&
    typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === "function"
  ) {
    return window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25,
    });
  }
  return compose;
};

// Middleware creation
const createMiddleware = () => applyMiddleware(thunk);

// Store configuration function
const configureStore = () => {
  const enhancers = createEnhancers();
  const middleware = createMiddleware();

  // Create store with the root reducer (no persistence)
  const store = createStore(rootReducer, enhancers(middleware));

  return store;
};

// Export the configured store
const store = configureStore();
export { store };
